import { Footer } from '../Footer';
import { Grid } from '../Grid';
import { Header } from '../Header';
import { TutorialModal } from '../Toturial/TutorialModal';
import { useEffect } from 'react';

import * as S from './styles';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import { useCatalogue } from '../Catalogue/Catalogue';

const Layout = () => {
  const { trackPageView } = useMatomo();

  useEffect(() => {
    trackPageView({
      documentTitle: 'Configurator Dashboard'
    });
  }, []);

  useCatalogue();

  return (
    <S.Layout className="configurator-layout">
      <TutorialModal />
      <Header />
      <div className="main-content">
        <Grid />
      </div>
      <Footer />
    </S.Layout>
  );
};

export default Layout;
